module.exports = {"id":"166937","name":"Andrey Sinitsyn","rating":"74","photo":"./data/images/photos/0/166937.png","club":{"name":"FK Krasnodar","logo":"./data/images/clubs/FKKrasnodar.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndreySinitsyn0.json
// module id = 401
// module chunks = 0